/**
 * Providers whose logo is dark on transparent, mapped to the light-on-dark
 * logo shown instead in dark mode. Other providers' logos read on both themes.
 */
export const DARK_MODE_PROVIDER_LOGOS: Record<string, string> = {
  aws: 'aws-dark',
  github: 'github-dark',
};
